import { Component, Input, SimpleChanges } from "@angular/core";
import { PolicyHeaderComponent } from "../../policy-documents/policy-header/policy-header.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-aul-101-24",
    standalone: true,
    imports: [PolicyHeaderComponent, CommonModule],
    templateUrl: './aul-101-24.component.html',
    styleUrl: './aul-101-24.component.scss'
})
export class Aul10124Component{
    @Input() quoteDetails!: any;
    surplusFeeTotal = 0;
    
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['quoteDetails']) {
            this.quoteDetails = changes['quoteDetails'].currentValue?.aul10124;
            const qislFeeDetails = this.quoteDetails?.qislFeeDetails || [];
      
      this.surplusFeeTotal = Array.isArray(qislFeeDetails)
        ? qislFeeDetails.reduce(
            (sum: number, detail: any) =>
              sum + (detail?.feeAmount !== undefined && detail?.feeAmount !== null
                ? Number(detail.feeAmount)
                : 0),
            0
          )
        : 0;
        }
    }
}